import React from "react";
import Button from "../Button";

interface DialogFooterProps {
  submitText?: string;
  onSubmit?: () => void;
}

export default function DialogFooter({ submitText, onSubmit }: DialogFooterProps) {
  return (
    <div className="modal-footer">
      <Button
        text="Close"
        buttonStyle="btn-secondary"
        data-bs-dismiss="modal"
      />

      {submitText && (
        <Button
          text={submitText}
          onClick={onSubmit}
          data-bs-dismiss="modal"
        />
      )}
    </div>
  );
}
